export const getTitleText = (title: string) => {
  if (!title) {
    return <title>Eventbrite Help Center</title>
  }

  return <title>{`${title}`}</title>
}

export const generateDescriptionMetaTag = (description: string) => {
  if (!description) {
    return null
  }
  return (
    <meta
      name="description"
      content={description ? description : "default description"}
    />
  )
}

export const generateRobotsMetaTag = (index: boolean, crawl: boolean) => {
  // If both of these values are true, or no data was passed in, no robots meta tag is necessary
  if ((index && crawl) || index === undefined || crawl === undefined) {
    return null
  }
  let content = ""

  if (!index) {
    content = content + "noindex"
  }
  if (!crawl) {
    if (content.length > 0) {
      content = content + ", nofollow"
    } else {
      content = content + "nofollow"
    }
  }
  return <meta name="robots" content={content} />
}

const GATSBY_PATH_PREFIX = process.env.GATSBY_PATH_PREFIX || "/help"

export const handleUrlString = (
  urlString: string,
  options: { removePrefix?: boolean } = {}
): string => {
  if (!urlString) {
    return "/"
  }

  let newUrlString = urlString
  const removePrefix = options?.removePrefix

  if (newUrlString?.includes("//")) {
    newUrlString = newUrlString?.replace(/\/\//g, "/")
  }

  if (newUrlString?.includes("/help/help")) {
    newUrlString = newUrlString?.replace("/help/help", "/help")
  }

  if (removePrefix) {
    newUrlString = newUrlString?.replace(GATSBY_PATH_PREFIX, "")
  }

  if (!newUrlString?.startsWith("/")) {
    newUrlString = "/" + newUrlString
  }

  if (!newUrlString?.endsWith("/")) {
    newUrlString = newUrlString + "/"
  }

  return newUrlString?.replace("/help/help", "/help")
}
